import service from '@/store/services/vendors/labourer-attendance-service';

const state = {
    list: {},
    labourerAttendance: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, labourerAttendance) => {
        state.labourerAttendance = labourerAttendance;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(labourerAttendance => {
                commit('SET_RESOURCE', labourerAttendance);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(labourerAttendance => {
                commit('SET_RESOURCE', labourerAttendance);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((labourerAttendance) => {
                commit('SET_RESOURCE', labourerAttendance);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((labourerAttendance) => {
                commit('SET_RESOURCE', labourerAttendance);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    labourerAttendance: state => state.labourerAttendance,
    dropdown: (state) => {
        return state.list.map(labourerAttendance => ({
            id: labourerAttendance.id,
        }));
    }
};

const labourerAttendances = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default labourerAttendances;
